import { render, staticRenderFns } from "./troca-rapida.vue?vue&type=template&id=64999722&scoped=true&"
import script from "./troca-rapida.vue?vue&type=script&lang=js&"
export * from "./troca-rapida.vue?vue&type=script&lang=js&"
import style0 from "./troca-rapida.vue?vue&type=style&index=0&id=64999722&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64999722",
  null
  
)

export default component.exports